// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9721a396","650":"9fb23469","667":"ef22a885","779":"6b3b08e3"}[chunkId] + ".chunk.js";
};